import axios from 'axios';
import { SearchData } from '../SearchModule';
import klass from '../view/RecentSerachesSection.module.scss';
import { RecentSearch, RecentSearchesSection, RecentSearchRemoveEvent } from '../view/RecentSearchesSection';

interface RecentSearchesControllerOptions {
  onRemoveAll?: () => Promise<void>;
  onRemoveOne?: (search: string) => Promise<SearchData[]>;
}

export class RecentSearchesSectionController {
  constructor(
    private options: RecentSearchesControllerOptions = {
      // constructor 가 마무리 되기 전까지 this 가 존재하지 않음
      onRemoveAll: RecentSearchesSectionController.defaultRemoveAllApi,
      onRemoveOne: RecentSearchesSectionController.defaultRemoveOneApi,
    },
  ) {}

  public delegateEvents(view: RecentSearchesSection) {
    view.delegate('click', `.${klass.remove_all}`, async (_e) => {
      if (this.options.onRemoveAll) {
        await this.options.onRemoveAll();
        view.data.recent_searches = [];
        view.redraw();
      }
    });

    view.delegate(RecentSearchRemoveEvent, RecentSearch, async (e, _view) => {
      if (this.options.onRemoveOne) {
        try {
          const updated = await this.options.onRemoveOne(e.detail);
          view.setData({ recent_searches: updated });
          view.redraw();
        } catch (err) {
          // FIXME: handle error
        }
      }
    });
  }

  static defaultRemoveAllApi = async () => {
    await axios.delete(`/${T.lang}/@api/keywords/history/all`);
  };

  static defaultRemoveOneApi = async (search: string) => {
    const { data } = await axios.delete<{ queries: string[] }>(`/${T.lang}/@api/keywords/history`, {
      params: { q: search },
    });
    return data.queries.map((name) => ({ name })) as SearchData[];
  };
}
